import { useCallback } from 'react';

export const useAppForm = () => {

  const getFormProps = useCallback(({
    appForms,
    appFormItems,
    appFormType,
    appFormTypes,
    dataPropType,
    propIgnores,
    form_handlers,
    vit,
  }) => {
    let _formProps;

    const data = {
      dataPropType,
      viewProps: null,
      noProps: false,
      form_handlers,
    }

    if (appForms) {
      if (appFormTypes) {
        let allViewProps = {}
        appFormTypes.forEach(aft => {
          if (appForms[aft]) {
            const _viewProps = appForms[aft]
            allViewProps = { ...allViewProps, ..._viewProps }
          }
        })
        if (allViewProps && propIgnores) propIgnores.forEach(pi => { delete allViewProps[pi] })
        const fpp = { updateProps: { vit }, viewProps: allViewProps }
        _formProps = getFormPropz(fpp)
        data.viewProps = allViewProps
      } else if (appFormType && appForms[appFormType]) {
        const _viewProps = appForms[appFormType]
        if (_viewProps && propIgnores) propIgnores.forEach(pi => { delete _viewProps[pi] })
        const fpp = { updateProps: { vit }, viewProps: _viewProps }
        _formProps = getFormPropz(fpp)
        data.viewProps = _viewProps
      } else if (appFormItems) {
        const fpp = { updateProps: { vit }, viewProps: appFormItems }
        _formProps = getFormPropz(fpp)
        data.viewProps = appFormItems
      } else {
        data.noProps = true
      }
    }

    const _data = { ...data, formProps: _formProps }

    return { _formProps: _data }

  }, [])

  const getFormPropz = useCallback((props) => {
    const {
      camelCase,
      creds,
      data_init,
      editableItem,
      form_handlers,
      formActions,
      handlers,
      ignorePropSections,
      menuType,
      readOnlyForm,
      formHandler,
      settingsType,
      source,
      updateProps,
      useWizard,
      viewItem,
      viewProps,
      viewPropsAllowed,
    } = props
    return {
      creds,
      data_init,
      editableItem,
      form_handlers,
      formActions,
      menuType,
      ignorePropSections,
      handlers: handlers,
      readOnlyForm,
      settingsType,
      source,
      updateProps,
      useWizard,
      formHandler,
      viewItem,
      viewProps,
      viewPropsAllowed,
      camelCase,
    }
  }, [])


  return { getFormProps, getFormPropz }
}
